import {
  Box,
  Container,
  Grid,
  IconButton,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import EmailIcon from "@mui/icons-material/Email";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import XIcon from "@mui/icons-material/X";

const socialLinks = [
  {
    icon: <FacebookIcon />,
    label: "Facebook",
    href: "https://www.facebook.com/profile.php?id=100080696780274",
  },
  {
    icon: <InstagramIcon />,
    label: "Instagram",
    href: "https://www.instagram.com/einstein_seedsalumni/",
  },
  //   { icon: <LinkedInIcon />, label: "LinkedIn", href: "https://linkedin.com" },
  //   { icon: <XIcon />, label: "X", href: "https://x.com" },
];

const quickLinks = [
  { label: "Home", href: "/" },
  { label: "Association Members", href: "/association-members" },
];

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        background: "linear-gradient(135deg, #0f172a 0%, #111827 100%)",
        color: "#f8fafc",
        py: { xs: 5, md: 7 },
        mt: 6,
        borderTop: "1px solid rgba(255,255,255,0.1)",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1.5 }}>
              Einstein Seeds
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "rgba(248,250,252,0.78)", lineHeight: 1.8 }}
            >
              Empowering youth and communities through education, innovation,
              and lasting impact.
            </Typography>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1.5 }}>
              Contact Us
            </Typography>
            <Stack spacing={1.2} sx={{ color: "rgba(248,250,252,0.8)" }}>
              <Stack direction="row" spacing={1} alignItems="center">
                <EmailIcon fontSize="small" />
                <Typography variant="body2">eseedsalumni@gmail.com</Typography>
              </Stack>
              <Stack direction="row" spacing={1} alignItems="center">
                <PhoneIcon fontSize="small" />
                <Typography variant="body2"></Typography>
              </Stack>
              <Stack direction="row" spacing={1} alignItems="center">
                <LocationOnIcon fontSize="small" />
                <Typography variant="body2">SeethaParpanallur, TN</Typography>
              </Stack>
            </Stack>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1.5 }}>
              Quick Links
            </Typography>
            <Stack spacing={1}>
              {quickLinks.map((link) => (
                <Link
                  key={link.label}
                  component={RouterLink}
                  to={link.href}
                  underline="hover"
                  sx={{ color: "rgba(248,250,252,0.8)", fontSize: "0.95rem" }}
                >
                  {link.label}
                </Link>
              ))}
            </Stack>

            <Typography
              variant="subtitle2"
              sx={{ fontWeight: 600, mt: 2.5, mb: 1 }}
            >
              Follow Us
            </Typography>
            <Stack direction="row" spacing={0.5}>
              {socialLinks.map((social) => (
                <IconButton
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noreferrer"
                  component="a"
                  sx={{
                    color: "#f8fafc",
                    backgroundColor: "rgba(255,255,255,0.08)",
                    border: "1px solid rgba(255,255,255,0.12)",
                    borderRadius: "50%",
                    width: 40,
                    height: 40,
                    mb: 1,
                    "&:hover": {
                      backgroundColor: "#2563eb",
                      transform: "translateY(-2px)",
                    },
                  }}
                  aria-label={social.label}
                >
                  {social.icon}
                </IconButton>
              ))}
            </Stack>
          </Grid>
        </Grid>

        <Typography
          variant="body2"
          sx={{
            mt: 4,
            pt: 2,
            borderTop: "1px solid rgba(255,255,255,0.12)",
            textAlign: "center",
            color: "rgba(248,250,252,0.65)",
          }}
        >
          © 2026 Einstein Seeds. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
}

export default Footer;
